import { render, staticRenderFns } from "./justificationTypeIndex.vue?vue&type=template&id=a1df5a14&"
import script from "./justificationTypeIndex.vue?vue&type=script&lang=js&"
export * from "./justificationTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports